module.exports = __webpack_public_path__ + "2c772c98c572c5a7c8248b55e39a9b67.png";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/saaspass-connect/manage/images/buttons/hdpi/login_with-saaspass.png
// module id = 459
// module chunks = 0